var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeCareNewEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff7e74;}.cls-2{fill:#ffe9e9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_136",
    "data-name": "Layer 136"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300,
    cy: 299.42,
    r: 300
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447.32,244H357.05V158.79a56.19,56.19,0,0,0-56-56h0a56.19,56.19,0,0,0-56,56V244H164.83a56.2,56.2,0,0,0-56,56h0a56.19,56.19,0,0,0,56,56H245v85.27a56.2,56.2,0,0,0,56,56h0a56.2,56.2,0,0,0,56-56V356h90.27a56.19,56.19,0,0,0,56-56h0A56.2,56.2,0,0,0,447.32,244Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCareNewEntry);
export default __webpack_public_path__ + "static/media/home_care_new_entry.9aad98a190252c5e3148fd3b0a8523e1.svg";
export { ForwardRef as ReactComponent };